<template>
  <div class="article">
    <b-container fluid="xxl" v-if="article">
      <b-row>
        <b-col v-if="config.editable">
          <button
            v-if="$store.getters.checkRole('legam.dict.article.delete')"
            @click="deleteArticle"
            class="btn-legam-xs mb-2 btn-danger"
          >
            <b-icon icon="trash2-fill"></b-icon>
            Delete
          </button>
          <b-form-checkbox
            v-model="article.isPublished"
            size="sm"
            class="mb-2"
            name="check-button"
            switch
            :disabled="!$store.getters.checkRole('legam.dict.article.modify') || !config.editable"
          >
            Published
          </b-form-checkbox>

          <b-form-checkbox
            v-model="article.isDoclinged"
            size="sm"
            class="mb-4"
            name="check-button"
            switch
            :disabled="!$store.getters.checkRole('legam.dict.article.modify') || !config.editable"
          >
            DocLing finished
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-group
            id="authors-group"
            :label="this.$t('ArticleAuthors')"
            label-for="authors"
          >
            <ArticleauthorSelect
              v-if="config.editable && $store.getters.checkRole('legam.dict.article.modify')"
              :selected="article.articleauthors.map(articleauthor => articleauthor.id)"
              @select="selectArticleauthor"
            />
            <span v-else-if="article.articleauthors.length" class="text-bold">
              {{ article.articleauthors.map(author => author.name).join(", ") }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
        </b-col>

        <b-col v-if="config.editable">
          <b-form-group
            id="article-etymon-group"
            label="Etymon:"
            label-for="article-etymon"
          >
            <LemmaSelect
              :lemma="article.articleEtymon"
              :isRequired=true
              :isArticleEtymon=true
              :articleId=article.id
              @select="etymonSelect"
              v-model="article.articleEtymon"
              v-if="$store.getters.checkRole('legam.dict.article.modify')"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
      <b-col>
        <b-form-group
          id="article-etymology-group"
          :label="this.$t('Etymology')"
          label-for="article-etymology"
        >
          <b-form-textarea
            v-if="config.editable && editMode"
            id="article-etymology"
            v-model="article.articleEtymology.description"
            placeholder="Etymology"
            rows="12"
            max-rows="12"
            :style="validateInput(article.articleEtymology.description) ? '' : 'background-color: bisque;'"
            :disabled="!$store.getters.checkRole('legam.dict.article.modify')"
          ></b-form-textarea>
          <p v-else v-html="prepareEtymologie(article.articleEtymology.description)"/>
        </b-form-group>
        <span v-if="editMode && config.editable">
          <button @click="saveArticle" class="btn-legam-xs mb-2 btn-primary" :disabled="!validateInput(article.articleEtymology.description)">
            <b-icon icon="lock-fill"></b-icon>
            Save Etymology
          </button>
          <button @click="cancelEdit" class="btn-legam-xs mb-2">
            Cancel
          </button>
        </span>
        <span v-else>
          <button @click="unlockEdit" v-if="config.editable && $store.getters.checkRole('legam.doc.document.modify')" class="btn-legam-xs mb-2">
            <b-icon icon="unlock-fill"></b-icon>
            Unlock editing
          </button>
          <button v-if="config.editable && !$store.getters.checkRole('legam.doc.document.modify') && $store.getters.checkRole('legam.doc.document.delete')" @click="deleteItem" class="btn-legam-xs mb-2 btn-danger">
            <b-icon icon="trash2-fill"></b-icon>
            Delete
          </button>
        </span>
      </b-col>
      </b-row>

      <hr>
      <b-row>
        <b-col cols="3">
          <h6 class="mt-5 legam-h6 with-line">
            {{ $t('Lemmas') }}
          </h6>
            <div class="add-new-box" v-if="showAddNewBox">
              <LemmaAutocomplete
                :allowNew="true"
                :withoutArticle="true"
                :articleId="article.id"
                @select="addNewLemma"
                @close="closeAddNewLemma"
              />
            </div>
              <TreeView
                v-if="article"
                @save="saveTree"
                :bullet="''"
                :editManualTreenumber="editManualTreenumber"
                v-bind:data="treeForLemma"
                @add="showAddNewBox=true"
                @save-numbers="saveManualNumbers"
                @cancel-edit-numbers="toggleManualTreenumbering"
                @cancel="showAddNewBox=false"
                :disableEdit="!config.editable || !$store.getters.checkRole('legam.dict.lemmatree.rearrange')"
                :disableAdd="!config.editable || !$store.getters.checkRole('legam.dict.article.modify')"
              >
                <template v-slot:leafNameDisplay="slotProps">
                  <span @click="loadLemma('left', slotProps.model.id)" v-html="slotProps.model.name"></span>
                  <span class="red" v-if="slotProps.model.checked == false" v-b-tooltip.hover title="Unchecked">✕</span>
                  <b-form-input
                    :id="slotProps.model.id"
                    v-if="editManualTreenumber"
                    class="manual-treenumber-edit"
                    v-model="slotProps.model.manualNumber"
                  ></b-form-input>
                  <span v-else class="manual-treenumber" v-html="slotProps.model.manualNumber"></span>

                  <span class="contextmenu" v-if="$store.getters.checkRole('legam.dict.lemmatree.rearrange')">
                    <button @click="loadLemma('left', slotProps.model.id)" class="btn-legam-tooltip">
                      <b-icon icon="layout-sidebar-inset"></b-icon>
                      Open
                    </button>
                    <template v-if="config.editable && !editManualTreenumber">
                      <div class="separator"></div>
                      <button @click="deleteLemma(slotProps.model.id)" class="btn-legam-tooltip">
                        <b-icon icon="trash-fill"></b-icon>
                        Remove
                      </button>
                      <button @click="moveSubtree(slotProps.model.id)" class="btn-legam-tooltip">
                        <b-icon icon="box-arrow-right"></b-icon>
                        Move to...
                      </button>
                      <button @click="toggleManualTreenumbering" class="btn-legam-tooltip">
                        <b-icon icon="box-arrow-right"></b-icon>
                        Renumber
                      </button>
                    </template>
                  </span>
                </template>
              </TreeView>
              <b-modal id="move-to-article" title="Move lemma to another article" ok-title="Close" size="lg">
                <ArticleAutocomplete :allowNew="false" @selectArticle="addLemmaSubtreeToArticle" />
              </b-modal>

          <div v-if="config.editable">

            <hr class="mt-4 mb-4">

            <b-form-group
              id="article-comment-group"
              label="Comment:"
              label-for="comment-contextLeft"
            >
              <b-form-textarea
                id="comment-contextLeft"
                v-model="article.comment"
                placeholder="Comment"
                rows="3"
                max-rows="6"
                :disabled="!$store.getters.checkRole('legam.dict.article.modify')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group
              id="dictionary-group"
              label="Dictionary:"
              label-for="dictionary"
            >
              <!-- <span v-html="article.dictionary.languageCode"></span> -->
              <DictionarySelect
                :selected="article.dictionaryId"
                @select="setDictionary"
                :multiple="false"
                v-if="$store.getters.checkRole('legam.dict.article.modify')"
              />
              <b-form-textarea
                id="comment-contextLeft"
                v-model="article.dictionary.acronym"
                disabled="true"
                rows="2"
                max-rows="3"
                v-else
              ></b-form-textarea>
            </b-form-group>
          </div>
        </b-col>
        <b-col>
          <b-row :class="(leftLemmaId && rightLemmaId) ? 'vertical-scroll' : ''">
            <b-col class="lemmaBox" v-if="leftLemmaId">
              <LemmaEditDetails
                :lemmaId="leftLemmaId"
                @close="leftLemmaId=null"
                :isEdit="true"
                :dictionaryId="article.dictionaryId"
                @update="updateArticle"
              />
            </b-col>

            <b-col class="lemmaBox" v-if="rightLemmaId">
              <LemmaEditDetails
                :lemmaId="rightLemmaId"
                @close="rightLemmaId=null"
                :isEdit="true"
                :dictionaryId="article.dictionaryId"
                @update="updateArticle"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="config.editable">
        <b-col>
          <div class="mt-4">
            <h6>Logs</h6>
            <ChangeLogsTable :objectType="'article'" :objectId="article.id" :key="'logs' + index" />
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="delete-lemmata"
      title="Delete Lemmata"
      ok-title="yes"
      cancel-title="no">
      <div class="d-block text-center">
        Delete Lemmata from this article as well?
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  /* .lemmaBox {
    overflow-y: scroll;
    height: 100%;
  } */

  *>>> .manual-treenumber {
    margin-right: 5px;
  }

  *>>> .manual-treenumber-edit {
    margin-right: 5px;
    width: 100px;
  }

  .contextmenu {
    width: 120px;
  }

  .vertical-scroll {
    height: 100vh;
    position: relative;
  }

  .lemma-highlighted {
    background-color: rgb(211, 243, 255);
    border-radius: 4px;
    padding: 5px;
  }

  .add-new-box {
    margin-top: -16px;
    background-color: #f1f1f1;
    margin-left: -8px;
    padding: 20px 7px 0;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    margin-bottom: 10px;
  }

  .move-to-article-box {
    margin-top: 10px;
    padding: 20px 0px 20px;
    border-radius: 5px;
    background-color: #f1f1f1;
    margin-bottom: 10px;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import LemmaEditDetails from '@/components/Lemma/EditDetails.vue'
  import LemmaAutocomplete from '@/components/Lemma/Autocomplete.vue'
  import LemmaSelect from '@/components/Lemma/LemmaSelect.vue'
  import DictionarySelect from '@/components/DictionarySelect.vue'
  import ArticleAutocomplete from '@/components/ArticleAutocomplete.vue'
  import ArticleauthorSelect from '@/components/Dictionary/ArticleauthorAutocomplete.vue'
  import TreeView from '@/components/TreeView.vue'
  import ChangeLogsTable from '@/components/ChangeLogsTable.vue'
  import router from '@/router'
  import config from '@/config.js'
  import { XMLStringIsWellFormed } from '@/utilities/xml-functions.js'

  export default {
    name: 'ArticleDetails',
    components: {
      LemmaEditDetails,
      LemmaAutocomplete,
      LemmaSelect,
      TreeView,
      ArticleAutocomplete,
      ChangeLogsTable,
      ArticleauthorSelect,
      DictionarySelect,
    },
    data(){
      return {
        leftLemmaId: null,
        rightLemmaId: null,
        occurrenceDetailsModel: null,
        logs: [],
        showAddNewBox: false,
        currentTab: 'list',
        moveToArticleLemmaId: null,
        index: 0,
        config: config,
        editMode: false,
        backupEtymology: null,
        editManualTreenumber: false
      }
    },
    computed: {
      treeManualNumbers() {
        return Object.entries(this.article.lemmas).map(([id, values]) => [id, values.tree.manualNumber])
      },
      treeForLemma(){
        return this.makeLemmaTree(this.article.lemmaTree, this.leftLemmaId).children
      },
      ...mapState({
        article: state => state.article.article
      })
    },
    methods: {
      saveManualNumbers() {
        const nums = Array.from(document.getElementsByClassName("manual-treenumber-edit")).map(x => [x.id, x.value])

        nums.forEach(([id, num]) => {
          this.article.lemmas[id].tree.manualNumber = num
        })

        this.toggleManualTreenumbering()
        this.saveTree(this.treeForLemma)
      },
      toggleManualTreenumbering() {
        this.editManualTreenumber = !this.editManualTreenumber
      },
      prepareEtymologie(text) {
        let footnoteIndex = 1
        let footnotes = []
        let index = text.indexOf("<footnote>")
        while (index > -1) {
          footnotes.push([text.substring(index+10, text.indexOf("</footnote>")), footnoteIndex])
          text = text.substring(0, index) + `<sup>${footnoteIndex}°</sup> ` + text.substring(text.indexOf("</footnote>") + 11)
          index = text.indexOf("<footnote>")
          footnoteIndex++
        }
        if (footnotes.length) {
          text = text + `<br>`
        }
        for (const [footText, index] of footnotes) {
          text = text + `<sup>${index}°</sup> ${footText}<br>`
        }
        return text
      },
      validateInput(input) {
        return XMLStringIsWellFormed(input)
      },
      unlockEdit() {
        this.editMode = true
        this.backupEtymology = this.article.articleEtymology.description
      },
      cancelEdit() {
        this.editMode = false
        this.article.articleEtymology.description = this.backupEtymology
        this.backupEtymology = null
      },
      async deleteArticle() {
        const conf = await this.$bvModal.msgBoxConfirm('are you sure?')

        if (conf) {
          let deleteLemmata = false;

          if (Object.keys(this.article.lemmas).length > 0) {
            deleteLemmata = await this.$bvModal.msgBoxConfirm('Delete all associated Lemmata?', {
              title: 'Delete Lemmata',
              size: 'md',
              okTitle: 'Yes',
              cancelTitle: "No",
            })
          }

          if (deleteLemmata) {
            Object.keys(this.article.lemmas).forEach(lemma =>
              this.$store.dispatch('deleteLemma', lemma)
            )
          }

          this.$store.dispatch('deleteArticle', {
            articleId: this.article.id
          }).then(() => {
              router.push(`/lemmas`)
          })
        }
      },
      async etymonSelect(lemma) {
        if (!lemma) {
          if (Object.keys(this.article.lemmas).length == 0) {
            this.$store.dispatch('addNotification', {
              type: 'warning',
              text: 'cannot remove article etymon if lemmatree is empty'
            })
            return
          }
          this.article.articleEtymon = {id: null}
        } else {
          this.article.articleEtymon = lemma
        }
        this.saveArticle()
        await new Promise(resolve => setTimeout(resolve, 200))
        this.updateArticle()
      },
      saveArticle(){
        this.$store.dispatch('saveArticle', this.article).then(() => {
          this.index++
        })
        this.editMode = false
      },
      setDictionary(dictionaries){
        let dictionary = dictionaries[0]
        this.article.dictionary = dictionary
        this.article.dictionaryId = dictionary.id
        this.saveArticle()
      },
      loadLemma(side, lemmaId){
        if (side == 'left'){
          this.leftLemmaId = lemmaId
          // this.makeLemmaTree(this.article.lemmaTree, lemmaId).children
        }
        else {
          this.rightLemmaId = lemmaId
        }
      },
      lemmaTreeDisplay(lemmaNode) {
        let returnForm = lemmaNode.lemmaForm

        if (lemmaNode.partofspeeches) {
          returnForm += ` <small>${lemmaNode.partofspeeches.map(e => e.name).join(", ")}</small>`
        }

        return returnForm
      },
      makeLemmaTree(jsonData, selLemmaId){
        return {
          id: jsonData.id,
          name: jsonData.id ? this.lemmaTreeDisplay(this.article.lemmas[jsonData.id]) : null,
          manualNumber: jsonData.id ? this.article.lemmas[jsonData.id].tree.manualNumber : null,
          highlight: jsonData.id == selLemmaId,
          checked: (jsonData.id ? this.article.lemmas[jsonData.id]?.tree?.checked : false),
          children: jsonData.children.map(node => {
            return this.makeLemmaTree(node, selLemmaId)
          })
        }
      },
      moveSubtree(nodeId){
        this.moveToArticleLemmaId = nodeId
        this.$bvModal.show('move-to-article')
        // this.$bvModal.msgBoxConfirm('Are you sure?')
        //   .then(value => {
        //     if (value){

        //     }
        //   })
      },
      saveTree(tree){
        this.showAddNewBox = false
        this.$store.dispatch('saveArticleTree', {
          tree: {'children': tree, 'id': null},
          articleId: this.article.id,
          manualNumbers: this.treeManualNumbers
        }).then(() => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Article tree saved`
          })
          this.updateArticle()
        })
      },
      showAddNewLemma(){
        this.showAddNewBox = true
      },
      closeAddNewLemma(){
        this.showAddNewBox = false
      },
      tabChange(tab){
        this.currentTab = tab
        if (tab == 'list'){
          this.showAddNewBox = false
        }
      },
      addNewLemma(lemma){
        this.article.lemmas[lemma.id] = lemma
        if (
          this.article.lemmaTree === null ||
          (
            this.article.lemmaTree.id === null &&
            this.article.lemmaTree.children.length === 0
          )
        ){
          this.article.lemmaTree = {
            id: lemma.id,
            children: []
          }
        }
        else {
          this.article.lemmaTree.children.push({id: lemma.id, children: []})
        }
        this.$store.dispatch('saveArticleTree', {
          tree: this.article.lemmaTree,
          articleId: this.article.id,
          manualNumbers: this.treeManualNumbers
        }).then(() => {
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Lemma added to article`
          })
          this.closeAddNewLemma()
          this.updateArticle()
        })
      },
      getSubLemmas(lemmaId) {
        let retVal = []
        let that = this

        function findSubtree(findLemmaId, root){
          let retVal = null
          if (root.id == findLemmaId) {
            return root
          }

          for(let lemma of root.children) {
            retVal = findSubtree(findLemmaId, lemma)
            if (retVal){
              break
            }
          }
          return retVal
        }

        // Find node
        let node = findSubtree(lemmaId, this.article.lemmaTree)

        function recNode(node){
          let retVal = []
          for(let lemmaTree of node.children) {
            retVal.push(that.article.lemmas[lemmaTree.id])
            retVal = retVal.concat(recNode(lemmaTree))
          }
          return retVal
        }

        if (node && node.children){
          retVal = recNode(node)
        }
        return retVal
      },
      deleteLemma(lemmaId) {
        if (Object.keys(this.article.lemmas).length < 2 && !this.article.articleEtymon) {
          this.$store.dispatch('addNotification', {
            type: 'warning',
            text: 'cannot empty tree if no article etymon is set'
          })
          return
        }
        let text = ['Are you sure?']
        let lemmas = this.getSubLemmas(lemmaId).map(lemma => `"${lemma.lemmaForm}"`).join(', ')

        if (lemmas) {
          text.push(this.$createElement('div', {
            class: {
              'mt-2': true
            }
          }), `The following sublemma(s) ${lemmas} will be also be removed from the article!`)
        }
        this.$bvModal.msgBoxConfirm(this.$createElement('div', text))
          .then(async value => {
            if (value){
              await this.deleteNode(lemmaId)
              this.$store.dispatch('saveArticleTree', {
                tree: this.article.lemmaTree,
                articleId: this.article.id,
                manualNumbers: this.treeManualNumbers
              }).then(() => {
                this.$store.dispatch('addNotification', {
                  type: 'success',
                  text: `Lemma removed from article`
                })
                this.updateArticle()
              })
            }
          })
      },
      deleteNode(lemmaId){
        // TODO: move to utils
        function recDeleteNode(children, lemmaIdToDelete){
          let retVal = []
          for(let lemma of children){
            if (lemma.id != lemmaIdToDelete){
              lemma.children = recDeleteNode(lemma.children, lemmaIdToDelete)
              retVal.push(lemma)
            } 
          }
          return retVal
        }

        let ids = []
        function toRemoveLemmata(children, lemmaIdToDelete, toRemove) {

          for(let lemma of children){
            if (lemma.id == lemmaIdToDelete) toRemove = true
            toRemoveLemmata(lemma.children, lemmaIdToDelete, toRemove)
            if (toRemove) ids.push(lemma.id)
            toRemove = false
          }
        }

        toRemoveLemmata(this.article.lemmaTree.children, lemmaId, false)


        ids.forEach(id => delete this.article.lemmas[id])
        
        this.article.lemmaTree = {
          id: this.article.lemmaTree.id,
          children: recDeleteNode(this.article.lemmaTree.children, lemmaId)
        }

        if (this.leftLemmaId == lemmaId){
          this.leftLemmaId = null
        }
        if (this.rightLemmaId == lemmaId){
          this.rightLemmaId = null
        }
      },
      addLemmaSubtreeToArticle(article){
        this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value){
              this.$bvModal.hide('move-to-article')
              this.$store.dispatch('moveLemmaToArticle', {
                newArticleId: article.id,
                lemmaId: this.moveToArticleLemmaId,
                articleId: this.article.id
              }).then(async () => {
                this.deleteNode(this.moveToArticleLemmaId)
                this.moveToArticleLemmaId = null
                this.$store.dispatch('addNotification', {
                  type: 'success',
                  text: `Lemma subtree moved to another article`
                })
                await new Promise(resolve => setTimeout(resolve, 300))
                const link = router.resolve({ path: `/article/${article.id}` })
                window.open(link.href, '_blank')
              })
            }
          })
      },
      selectArticleauthor(articleauthors){
        this.article.articleauthors = articleauthors
        this.saveArticle()
      },
      moveToNewArticle(event){
        event.preventDefault()
        this.addLemmaSubtreeToArticle(null)
      },
      updateArticle(){
        this.$store.dispatch('loadArticle', this.article.id)
        this.index++
      }
    }
  }
</script>
